import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomTable from "../../../Components/Table/CustomTable";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setHeaderName,
  setSubHeaderName,
} from "../../../ReduxStore/Slices/headerSlice";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import actions from "../../../ReduxStore/actions";
import { Formik, Form } from "formik";
import CustomUploadComponent from "../../../Components/CustomExcelUpload/CustomExcelUpload";
import { toast } from "react-toastify";
import { adminUrl } from "../../../constants";
import CustomDropdownMui from "../../../Components/CustomDropDown/CustomDropdown";
import BellCurveChart from "./BellCurveChart";
import * as Yup from "yup";
import { setInitialStateOfgetBellCurveReportByAppraisalYear } from "../../../ReduxStore/Slices/UploadFile/getBellCurveReportByAppraisalYear";
import FullPageLoader from "../../../Components/FullPageLoader/FullPageLoader";

const validationSchema = Yup.object().shape({
  appraisalYear: Yup.string().required("Appraisal year is required"),
});

const BellCurveMainPage = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [subDepartmentNames, setSubDepartmentNames] = useState([]);

  const { getAllDepartments } = useSelector(
    (state) => state?.getAllDepartments
  );

  const { getAllAppraisalYears } = useSelector(
    (state) => state?.getAllAppraisalYears
  );

  useEffect(() => {
    const fetchData = async () => {
      const data1 = {
        data: {},
        method: "get",
        apiName: "getAllDepartments",
      };
      const responseData = dispatch(actions.GETALLDEPARTMENTS(data1));
      console.log(responseData, "responseData");
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const data1 = {
        data: {},
        method: "get",
        apiName: "getAllAppraisalYears",
      };
      const responseData = dispatch(actions.GETALLAPPRAISALYEAR(data1));
      console.log(responseData, "responseData");
    };
    fetchData();
  }, []);

  const departmentOptions = getAllDepartments?.data?.map((data) => ({
    value: data?.department_id,
    label: data?.department_name,
  }));

  const appraisalYearOptions = getAllAppraisalYears?.data?.map((data) => ({
    value: data?.appraisal_year_id,
    label: data?.appraisal_year,
  }));

  const handleDepartmentChange = (selectedId) => {
    console.log("Selected department ID:", selectedId);

    // setSelectedCountryId(selectedId);
    setSubDepartmentNames([]); // Reset sub departments

    if (selectedId) {
      fetchSubDepartments(selectedId);
    }
  };

  // Fetch states based on selected country
  const fetchSubDepartments = async (department_id) => {
    const data = {
      data: {
        // country_id: countryId
      },
      method: "get",
      apiName: `getSubDepartmentsByDepartmentId/${department_id}`,
    };

    const response = await dispatch(
      actions.GETSUBDEPARTMENTSBYDEPARTMENTID(data)
    );

    if (
      response?.payload?.message === "All sub-departments fetched successfully."
    ) {
      const formattedStates =
        response?.payload?.data?.map((state) => ({
          label: state.sub_department_name,
          value: state.sub_department_id,
        })) || [];

      setSubDepartmentNames(formattedStates);
    }
  };

  const handleSubmit = async (values, { resetForm }) => {
    console.log(values, "vaaaaaaaaaal");
    setLoading(true);

    const data1 = {
      data: {
        appraisal_year_id: values?.appraisalYear,
        department_id: values?.department,
        sub_department_id: values?.subdepartment,
      },
      method: "post",
      apiName: "getBellCurveReportByAppraisalYear",
    };
    const responseData =await dispatch(
      actions.GETBELLCURVEREPORTBYAPPRAISALYEAR(data1)
    );
    console.log(responseData?.payload?.message, "responseData1111");

    if (responseData?.payload?.message === "Bell Curve report generated successfully.") {
      setLoading(false);
    } 
    else {
      setLoading(false);
      // toast.error("Some issuesBell Curve report ")
      toast.error("Bell Curve report has some issues");
    }

    // resetForm()
  };

  useEffect(() => {
    dispatch(setHeaderName("Reports"));
    dispatch(setSubHeaderName("Bell Curve Reports"));
  }, [dispatch]);
  const handleClearFilter = (resetForm) => {
    resetForm();
    dispatch(setInitialStateOfgetBellCurveReportByAppraisalYear());
  };

  return (
    <div>
      <Box
        sx={{
          background: "white",
          p: 3,
          mb: 2,
          mt: 2,
        }}
      >
        {loading && <FullPageLoader />}

        <Typography
          variant="subtitle2"
          sx={{ color: "black", fontSize: "18px" }}
        >
          Bell Curve
        </Typography>

        <Formik
          enableReinitialize
          initialValues={{
            department: "",
            subdepartment: "",
            appraisalYear: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            errors,
            touched,
            handleChange,
            values,
            setFieldValue,
            resetForm,
            isSubmitting,
          }) => (
            <Form>
              <Grid container spacing={2} mt={2}>
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <CustomDropdownMui
                    name="appraisalYear"
                    label="Appraisal Year"
                    custPlaceholder="-- Select appraisalYear --"
                    options={appraisalYearOptions}
                  />
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                  <CustomDropdownMui
                    name="department"
                    label="Department"
                    custPlaceholder="-- Select Department --"
                    options={departmentOptions}
                    onChange={handleDepartmentChange}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <CustomDropdownMui
                    name="subdepartment"
                    label="Sub Department"
                    custPlaceholder="-- Select Sub Department --"
                    options={subDepartmentNames}
                  />
                </Grid>

                {/* {!showExcelUpload && ( */}
                <Grid item size={{ xs: 12 }} sx={{ mt: 3 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    onClick={() => {
                      handleClearFilter(resetForm);
                    }}
                    sx={{
                      background: "#e3e2e2",
                      textTransform: "none",
                      color: "black",
                      mr: 2,
                      boxShadow: "none",
                    }}
                  >
                    Clear Filter
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      background: "var(--main-color)",
                      textTransform: "none",
                    }}
                  >
                    Apply Filter
                  </Button>
                </Grid>
                {/* )} */}
              </Grid>
            </Form>
          )}
        </Formik>

        <BellCurveChart />
      </Box>
    </div>
  );
};

export default BellCurveMainPage;
